<template>
  <div class="box">
    <div class="content w-1400">
      <div class="logo-word">
        <!-- <img class="logo-big" src="../../static/index/hualianwang.png"/> -->
        <!--        <div class="word-big">-->
        <!--          <div class="china-word">化联网</div>-->
        <!--          <div class="english-word">Ruitian Huagong</div>-->
        <!--        </div>-->
      </div>
      <login-box @changeOrder="changeOrder" :show-home="true"></login-box>
    </div>
    <Post_Inquiry :dialogVisible="showInquiry" @close="changeOrder(false)" ></Post_Inquiry>
  </div>
</template>
<script>
import loginBox from "@/components/public/login-box.vue";
import Post_Inquiry from "../../components/addInfo/post_Inquiry.vue";

export default {
  components: {Post_Inquiry, loginBox},
  data() {
    return {
      showInquiry:false
    };
  },
  mounted() {
  },
  methods: {
    goRegister() {
      this.$router.push("/register");
    },
    changeOrder(e){
      this.showInquiry=e
    }
  },
};
</script>
<style scoped lang="scss">
.box {
  width: 100vw;
  height: 100vh;
  background: url("../../static/login/login-bj.png") no-repeat center center;
  overflow: visible;
  background-size: 100% 100%;

  .content {
    padding-top: 109px;
    display: flex;
    justify-content: space-between;

    .logo-word {
      height: 61px;
      display: flex;
      color: #000000;
      //width: 172px;
      align-items: center;
      margin-right: 32px;

      .logo-big {
        width: 200px;
        height: 62px;
        object-fit: contain;
      }

      .word-big {
        margin-left: 10px;

        .china-word {
          white-space: nowrap;
          font-size: 22px;
          // color: #00112b;
          color: #ffffff;
          font-weight: 700;
        }

        .english-word {
          white-space: nowrap;
          font-size: 11px;
          color: #ffffff;
        }
      }
    }

    .flex-inner-right {
      margin-top: 8%;
      width: 380px;
      height: 385px;
      background: #ffffff;
      box-shadow: 0px 0px 11px 1px rgba(0, 11, 28, 0.13);
      border-radius: 5px 5px 5px 5px;
      box-sizing: border-box;

      .flex-inner-right-img {
        position: absolute;
        margin-left: 334px;
        padding: 3px 3px 0 0;
        width: 44px;
        height: 44px;
      }

      .flex-inner-right-box {
        float: left;
        padding: 30px 13px;
        width: 100%;
        height: 100%;
        box-sizing: border-box;

        .flex-inner-right-box-title {
          font-weight: 800;
          font-size: 20px;
          color: #00112b;
          text-align: center;
        }

        .menu-box {
          padding-top: 20px;
          display: flex;
          align-content: center;
          border-bottom: 1px solid #e5e5e5;
          justify-content: space-around;
        }

        .menu-item {
          box-sizing: border-box;
          text-align: center;
          font-weight: bold;
          font-size: 14px;
          color: #00112b;
          padding-bottom: 12px;
          border-bottom: 1px solid transparent;
        }

        .menu-item-active {
          box-sizing: border-box;
          text-align: center;
          font-weight: bold;
          font-size: 14px;
          padding-bottom: 12px;
          color: #00112b;
          border-bottom: 1px solid #246dff;
        }

        .input-box {
          padding: 14px 40px 0;

          .input-item {
            margin-bottom: 30px;

            .input-error {
              line-height: 30px;
              font-weight: 400;
              font-size: 12px;
              color: #eb5637;
            }

            .input-item-box {
              height: 40px;
              line-height: 40px;
              background: #ffffff;
              border-radius: 2px 2px 2px 2px;
              border: 1px solid #eef0f5;
              padding: 0 13px;

              img {
                width: 13px;
                height: 13px;
                margin-right: 15px;
              }

              input {
                border: none;

                &:focus {
                  outline: none;
                  /* 移除默认的轮廓线 */
                  box-shadow: none;
                  /* 移除可能的阴影效果 */
                  border: none;
                  /* 确保没有边框 */
                  -webkit-appearance: none;
                  /* 移除iOS上的默认样式 */
                  -moz-appearance: none;
                  /* 移除Firefox上的默认样式 */
                }

                /* 移除自动填充时的背景色 */
                &:-webkit-autofill,
                &:-webkit-autofill:hover,
                &:-webkit-autofill:focus {
                  -webkit-box-shadow: 0 0 0 30px white inset !important;
                }
              }
            }
          }
        }

        .login-box {
          padding: 0 40px;

          .btn-size {
            width: 100%;
            height: 40px;
          }

          .login-box-text {
            font-weight: 400;
            font-size: 13px;
            color: #00112b;
            text-align: center;
            padding-top: 30px;
          }

          .color-blue {
            color: #0c60e6;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
